import { Injectable, Injector } from '@angular/core';
import { BaseService } from 'vnpost-shared';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CategoryUnitService extends BaseService {
  constructor(http: HttpClient, injector: Injector) {
    super(http, injector, `${environment.apiDomain.llbJavaEndpoint}/unit`);
  }

  getCategoryUnit(model): Promise<any> {
    const apiUrl = `${this.serviceUri}/getAll?search=${model?.code ?? ''}&status=${model?.status ?? ''}&&pageNo=${model?.pageNo ?? ''}&pageSize=${model?.pageSize ?? ''}`;
    return this._http
      .get<any>(apiUrl)
      .pipe(catchError((err) => this.handleError(err, this._injector)))
      .toPromise();
  }

  inactive(id: any): Promise<any> {
    const apiUrl = `${this.serviceUri}/inActive/${id}`;
    return this._http
      .put<any>(apiUrl, {})
      .pipe(catchError((err) => this.handleError(err, this._injector)))
      .toPromise();
  }
}
